import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {BrandData, ContentTypeData, TargetSession, TargetType} from "../../utils/types/article_target";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;
declare var page: any;

export class articleContentTypeSession_template extends vnTemplate {

    public validationsList: validationsList_template;
    protected parent: any;

    protected getTemplateName(): string {
        return "articleContentTypeSession_template";
    }

    protected getTemplateHtml(): string {
        return `
            <div data-bind="css: { 'is-visible': show() }" class="w-lightbox light-theme">
               <div class="lightbox-content" data-bind="attr: {id: 'brand-content-type-popup-' + type()}">
                  <div class="w-form lightbox-form">
                     <div class="form-header" >
                        <h3 class="form-title" data-bind="text: 'Add ' + type() + ' Exception: ' + brandName() + ' (' + year() +')'"></h3>
                        <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCancel }" ></button>
                     </div>
                     <div class="form-body" >
                        <div>${this.validationsList.getHtmlBuild()}</div>
                        <div class="form-group">
                            <div style="z-index: 100" class="w-form-dropdown-menu" data-bind="attr: {id: 'exceptions-' + year() + '-' + idBrand() + '-' + type() }">
                                <button class="btn-form light icon i-dropdown-simple i-t-option" style="width: fit-content" type="button" data-bind="event: { click: onClickDisplayContentTypesToggle }">Display Content Types</button>
                                <div class="w-form form-dropdown-menu">
                                    <button class="close-btn icon-only icon i-close"  type="button" data-bind="event: { click: onClickDisplayContentTypesToggle }"><span class="hide-text">close</span></button>
                                    <div class="form-group" data-bind="foreach: contentTypes" style="columns: 6;margin-top: 2.5rem;width: auto;">
                                          <div class="multi-row" style="margin-bottom: .25rem">
                                             <input type="checkbox" data-bind="checkedValue: $data, checked: $parent.chosenContentTypes, event: {change: $parent.onClickCheckBoxContentType}, attr: {id: 'content-type-' + id}">
                                             <label class="form-label icon i-check"  data-bind="text: name, attr: {for: 'content-type-' + id}"></label>
                                         </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group" style="max-height: 40rem; overflow: auto;">
                            <table class="list-action" style="margin: 0; min-width: 100rem">
                               <thead>
                                  <th></th>
                                  <!-- ko foreach: defaultMonths -->
                                  <th><span data-bind="text: $data"></span></th>
                                  <!-- /ko -->
                                  <th><span>Delete</span></th>
                               </thead>
                               <tbody>
                                  <tr>
                                     <td class="align-right">
                                        <div class="flex">
                                           <span class="list-brand dark" data-bind="text: brandName(), css: brandIcon()"></span>
                                        </div>
                                     </td>
                                     <!-- ko foreach: months -->
                                     <td>
                                        <span data-bind="text: $data.sessionTarget"></span>
                                     </td>
                                     <!-- /ko -->
                                     <td></td>
                                  </tr>
                                  <!-- ko foreach: contentTypeList -->
                                  <tr>
                                     <td class="align-right">
                                        <span data-bind="text: contentTypeName"></span>
                                     </td>
                                     <!-- ko foreach: exceptionMonths  -->
                                     <td>
                                        <input type="number" class="input-text" data-bind="event: {blur: $parent.onBlurInputSessionTarget }, attr: {'id' :  $data.idBrand + '-' + $data.year + '-' + $data.month, 'data-previous-value': $data.sessionTarget}, value: $data.sessionTarget, enable: $data.enabled" min="0" max="99999">
                                     </td>
                                     <!-- /ko -->
                                     <td class="align-center">
                                        <button class="btn border highlight only-icon icon i-delete" data-bind="event: { click: $parent.onClickDeleteSessionContentType }"></button>
                                     </td>
                                  </tr>
                                  <!-- /ko -->
                               </tbody>
                            </table>
                        </div>
                     </div>
                     <div class="form-footer">
                        <button class="btn " data-bind="event: { click: onClickCancel }" >Cancel</button>
                        <button class="btn  highlight" data-bind="event: { click: onClickSave }" >Save</button>
                     </div>
                  </div>
               </div>
            </div>
        `;
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form-article"];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            show: ko.observable(false),
            type: ko.observable(TargetType.SUCCESS),
            year: ko.observable(''),
            defaultMonths: ko.observableArray([]),
            contentTypes: ko.observableArray([]),
            chosenContentTypes: ko.observableArray([]),
            brandName: ko.observable(''),
            idBrand: ko.observable(''),
            brandIcon: ko.observable(''),
            months: ko.observableArray([]),
            contentTypeList: ko.observableArray([]),
            enabledMonths: ko.observableArray([]),
            contentTypesToDelete: ko.observableArray([]),
            unsavedContentTypes: ko.observableArray([]),
            onClickCancel: (data, event): void => {
                self.onClickCancel();
            },
            onClickSave: (data, event): void => {
                self.onClickSave();
            },
            onClickDeleteSessionContentType: (data, event):void => {
                self.onClickDeleteSessionContentType(data);
            },
            onClickDisplayContentTypesToggle: (data, event): void => {
                self.onClickDisplayContentTypesToggle();
            },
            onClickCheckBoxContentType: (data, event): void => {
                self.onClickCheckBoxContentType(data);
            }
        };
    }
    protected initPartial() {

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.validationsList.setWidth('100%');

        this.initializeDefaultMonths();
    }


    private initializeDefaultMonths() {
        this.getTemplateViewModel().defaultMonths(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']);
    }

    public onClickCancel(): void {

        let contentTypeList = this.getContentTypeList();

        let changed: boolean = false;
        for (const contentTypeListElement of contentTypeList) {
            let changedExceptions = contentTypeListElement.exceptionMonths.filter((em) => em.sessionTarget != em.originalSessionTarget);
            if (changedExceptions.length > 0) {
                changed = true;
            }

        }
        if (changed) {
            if (confirm('Are you sure you want to cancel? any unsaved change will be lost.')) {
                this.resetAndHide();
            }

        } else {
            this.resetAndHide();
        }
    }

    public setParent(parent): void {
        this.parent = parent;
    }

    public getParent() {
        return this.parent;
    }

    public show() {
        this.getTemplateViewModel().show(true);
    }

    public hide() {
        this.getTemplateViewModel().show(false);
    }

    /**
     * Add a content type in the exception list
     */
    public onClickSave(): void {
        let dataToSave = this.getContentTypesExceptionsSaveRequest();
        this.caller.saveContentTypesExceptions(dataToSave)
    }

    public onClickDeleteSessionContentType(contentTypeData: ContentTypeData): void {

        this.addContentTypesToDelete(contentTypeData);
        let contentTypeList = this.getContentTypeList().filter((ctd) => ctd.idContentType != contentTypeData.idContentType);
        this.setContentTypeList(contentTypeList);

        let chosenContentTypes = this.getChosenContentTypes().filter((ct) => ct.id != contentTypeData.idContentType);
        this.setChosenContentTypes(chosenContentTypes);
    }


    public onClickDisplayContentTypesToggle(): void {

        this.toggleContentTypeOptionsPanelVisibility();
    }

    private toggleContentTypeOptionsPanelVisibility(): void {

        let popupId = this.buildPopupId();
        let element = document.getElementById(popupId);
        element.classList.toggle('is-visible');
    }

    private buildPopupId() {

        let popupId = 'exceptions-' + this.getYear() + '-' + this.getIdBrand() + '-' + this.getType();

        return popupId;
    }

    private buildPopupTypeId() {

        let popupId = 'brand-content-type-popup-' + this.getType();

        return popupId;
    }


    private hideContentTypeOptionsPanel() {
        let popupId = this.buildPopupId();
        let element = document.getElementById(popupId);
        if (element.classList.contains('is-visible')) {
            element.classList.remove('is-visible')
        }
    }
    public onClickCheckBoxContentType(contentType): void {

        let chosenContentType = this.getChosenContentTypes().filter((ct) => ct.id == contentType.id);
        if (chosenContentType.length > 0) {
            let contentTypeInDeleteList = this.getContentTypesToDelete().filter((ct) => ct.idContentType == contentType.id);
            if (contentTypeInDeleteList.length > 0) {
                let chosenContentTypeItem: ContentTypeData = contentTypeInDeleteList[0];
                this.addToContentTypeList(chosenContentTypeItem);
            } else {

                let contentTypeData: ContentTypeData = this.createContentTypeSessionTarget(contentType);
                this.addToContentTypeList(contentTypeData);
            }
        } else {

            // delete from the list
            let contentTypeInList = this.getContentTypeList().filter((ct) => ct.idContentType == contentType.id);
            if (contentTypeInList.length > 0) {
                let chosenContentTypeItem = contentTypeInList[0];
                this.addContentTypesToDelete(chosenContentTypeItem);
                let contentTypeList = this.getContentTypeList().filter((ctd) => ctd.idContentType != chosenContentTypeItem.idContentType);
                this.setContentTypeList(contentTypeList);
            }
        }
    }

    public onClickBrandContentType(data): void {
        this.getTemplateViewModel().show(true);
    }


    public onClickCollapseEvent(data) {
        data.collapseExpand(!data.collapseExpand());
    }

    public onClickClearUnsavedContentType() {
        this.removeItemFromContentTypeList( this.getTemplateViewModel().unsavedContentTypes() );
        this.resetUnsavedContentTypesException();


        if (!this.isRefreshContentType()) {
            this.caller.updateSessionBrandDisplay();
            this.toggleBrandContentTypeSaveDialogVisibility();
            this.getTemplateViewModel().showBrandContentTypeSessionTarget('');
        } else {
            this.toggleBrandContentTypeSaveDialogVisibility();
            this.setRefreshContentTypeFlag(false);

            let idBrand = this.getIdBrand();
            let year = this.getYear();

            this.caller.populateBrandContentTypeException(idBrand, year);
        }
    }

    public onClickBrandSaveHide() {
        this.toggleBrandSaveDialogVisibility();
        this.caller.updateSessionBrandDisplay();
        this.resetUnsavedBrandSessionTarget();
    }


    public onClickCancelDeleteContentTypeException() {
        this.toggleContentTypeDeleteDialogVisibility();


        // Reset the content to delete
        this.setContentTypesToDelete([]);
    }

    /**
     * set the selected brand and session
     */
    public setSelectedBrandSessionTarget(data: BrandData) {

        let contentTypeList = [];

        let selectedYear = this.caller.getSelectedYear();
        let contentTypes = this.caller.getContentTypes();
        let contentTypeIds = [];
        data.contentTypeList.forEach(function (contentTypeValue) {
            let exceptionMonths = [];

            contentTypeValue.exceptionMonths.forEach(function (exceptionMonth) {

                exceptionMonths.push({
                    idBrand:data.idBrand,
                    year:selectedYear,
                    month: exceptionMonth.month,
                    sessionTarget: exceptionMonth.sessionTarget,
                    originalSessionTarget: exceptionMonth.sessionTarget,
                    enabled: (exceptionMonth.enabled == true && data.enabledMonths.indexOf(exceptionMonth.month) !== -1)

                })
            });
            contentTypeIds.push(contentTypeValue.idContentType);
            contentTypeList.push({
                idContentType: contentTypeValue.idContentType,
                contentTypeName: contentTypeValue.contentTypeName,
                exceptionMonths: exceptionMonths,
            });
        });

        // contentTypes.map((ct) => ct['checked'] =  (contentTypeIds.indexOf(ct.id) !== -1 ));
        let chosenContentTypes = contentTypes.filter((ct) => contentTypeIds.indexOf(ct.id) !== -1 );
        this.setChosenContentTypes(chosenContentTypes);
        this.setContentTypes(contentTypes);
        this.setYear(selectedYear);
        this.setBrandName( data.brandName );
        this.setBrandIcon( data.iconImage );
        this.setIdBrand( data.idBrand );
        this.setMonths( data.months );
        this.setContentTypeList(contentTypeList); // watch out for this
        this.setEnabledMonths(data.enabledMonths);
        this.show();
    }

    public resetAndHide(): void {

        this.clearValidationSessionTargetsExceptions();
        this.hideContentTypeOptionsPanel();
        this.hide();
        this.setChosenContentTypes([]);
        this.setContentTypes([]);
        this.setYear('');
        this.setBrandName('');
        this.setBrandIcon('');
        this.setIdBrand('');
        this.setMonths([]);
        this.setContentTypeList([]); // watch out for this
        this.setEnabledMonths([]);
    }

    public getViewModelForContentTypeDelete() {
        let contentTypeDeleteValues = [];

        this.getContentTypesToDelete().forEach(function(item) {
            contentTypeDeleteValues.push({
                year: item.year,
                idBrand: item.idBrand,
                idContentType: item.idContentType,
            });
        });

        this.setContentTypesToDelete([]);

        return contentTypeDeleteValues;
    }

    /**
     * Return a list of sanitized brand content type
     */
    public getViewModelForContentTypeSave() {
        let sanitizedExceptionMonths = [];
        let sanitizedContentType = [];
        let contentTypeList = this.getContentTypeList();

        contentTypeList.forEach(function (item) {
            item.exceptionMonths.forEach(function(exceptionMonth) {
                if (exceptionMonth.sessionTarget > 0) {
                    sanitizedExceptionMonths.push(exceptionMonth);
                }
            })

            sanitizedContentType.push({
                contentTypeName: item.contentTypeName,
                idContentType: item.idContentType,
                exceptionMonths: sanitizedExceptionMonths
            });

            sanitizedExceptionMonths = [];
        });

        return [{
            year: this.getYear(),
            idBrand: this.getIdBrand(),
            contentTypeList: sanitizedContentType,
            months: [],
        }];
    }

    setYear(year): void {
        this.getTemplateViewModel().year(year);
    }

    getYear() {
        return this.getTemplateViewModel().year();
    }

    public getType() {
        return this.getTemplateViewModel().type();
    }

    public setType(type): void {
        this.getTemplateViewModel().type(type);
    }

    public setContentTypes(contentTypes): void {
        this.getTemplateViewModel().contentTypes(contentTypes);
    }

    public getContentTypes() {
        return this.getTemplateViewModel().contentTypes();
    }
    public setChosenContentTypes(chosenContentTypes): void {
        this.getTemplateViewModel().chosenContentTypes(chosenContentTypes);
    }

    public getChosenContentTypes() {
        return this.getTemplateViewModel().chosenContentTypes();
    }

    addChosenContentType(contentTypeId: number): void {
        let cts = this.getChosenContentTypes();
        cts.push(contentTypeId);

        this.setChosenContentTypes(cts);
    }

    setBrandName(brandName): void {
        this.getTemplateViewModel().brandName(brandName);
    }
    getBrandName(brandName) {
        return this.getTemplateViewModel().brandName();
    }
    setIdBrand(idBrand): void {
        this.getTemplateViewModel().idBrand(idBrand);
    }
    getIdBrand() {
        return this.getTemplateViewModel().idBrand();
    }
    setBrandIcon(brandIcon): void {
        this.getTemplateViewModel().brandIcon(brandIcon);
    }
    getBrandIcon() {
        return this.getTemplateViewModel().brandIcon();
    }

    setMonths(months): void {
        return this.getTemplateViewModel().months(months);
    }
    getMonths() {
        this.getTemplateViewModel().months();
    }
    setContentTypeList(contentTypeList): void {
        this.getTemplateViewModel().contentTypeList([]);
        this.getTemplateViewModel().contentTypeList(contentTypeList);
    }
    getContentTypeList() {
        return this.getTemplateViewModel().contentTypeList();
    }

    addToContentTypeList(contentTypeData: ContentTypeData): void {
        let contentTypeList = this.getContentTypeList();
        contentTypeList.push(contentTypeData);

        this.setContentTypeList(contentTypeList);
    }
    setEnabledMonths(enabledMonths) {
        this.getTemplateViewModel().enabledMonths(enabledMonths);
    }
    getEnabledMonths() {
        return this.getTemplateViewModel().enabledMonths();
    }

    getContentTypesToDelete() {
        return this.getTemplateViewModel().contentTypesToDelete();
    }
    setContentTypesToDelete(contentTypeIds) {
        this.getTemplateViewModel().contentTypesToDelete(contentTypeIds);
    }

    setUnsavedContentTypes(unsavedContentTypes): void {
        this.getTemplateViewModel().unsavedContentTypes(unsavedContentTypes);
    }

    addContentTypesToDelete(contentTypeData: ContentTypeData): void {

        this.getContentTypesToDelete().push(contentTypeData);

        this.setContentTypesToDelete(this.getContentTypesToDelete());
    }
    public toggleBrandSaveDialogVisibility() {
        document.getElementById('dialog-brand-save').classList.toggle('is-visible');
    }

    /**
     * Toggle the dialog for displaying confirmation on deleting a content type exception
     */
    public toggleBrandContentTypeSaveDialogVisibility() {
        document.getElementById('dialog-brand-content-type-save').classList.toggle('is-visible');
    }

    public toggleContentTypeDeleteDialogVisibility() {
        document.getElementById('dialog-content-type-delete').classList.toggle('is-visible');
    }

    public onBlurInputSessionTarget(data, event) {
        let targetId = event.target.id;
        let unsavedTargets = this.getTemplateViewModel().unsavedContentTypes();
        let index = unsavedTargets.indexOf(targetId)
        let previousValue = event.target.getAttribute('data-previous-value');


        if (previousValue != '' && previousValue != data.sessionTarget && index == -1) {
            unsavedTargets.push(targetId);
        } else {
            if (data.sessionTarget > 0 && index == -1) {
                unsavedTargets.push(targetId);
            } else if ( (data.sessionTarget <= 0 || data.sessionTarget == '') && index > -1) {
                unsavedTargets.splice(index, 1);
            }
        }

        this.resetUnsavedBrandSessionTarget();
        this.getTemplateViewModel().unsavedContentTypes(unsavedTargets);
    }

    public hasUnsavedBrandSessionTarget() {
        return (this.getTemplateViewModel().unsavedContentTypes().length > 0);
    }

    public hasUnsavedContentTypes() {
        return (this.getTemplateViewModel().unsavedContentTypes().length > 0);
    }

    public setRefreshContentTypeFlag(flag) {
        return this.getTemplateViewModel().isRefreshContentType(flag);
    }

    public isRefreshContentType(): boolean {
        return this.getTemplateViewModel().isRefreshContentType();
    }

    /**
     * Clear all unsaved target session brands
     */
    public resetUnsavedBrandSessionTarget() {
        this.getTemplateViewModel().unsavedContentTypes([]);
    }

    public resetUnsavedContentTypesException() {
       this.getTemplateViewModel().unsavedContentTypes([]);
    }

    protected removeItemFromContentTypeList(idContentTypes) {
        let contentTypes = [];
        let contentTypeList = this.getTemplateViewModel().contentTypeList();
        let unsavedContentTypes = this.getTemplateViewModel().unsavedContentTypes();

        contentTypeList.forEach(function(item) {
            if (!idContentTypes.includes(item.idContentType)) {
                contentTypes.push(item);
            }
        });

        this.setContentTypeList(contentTypes);

        idContentTypes.forEach(function (idContentType) {
            let index = unsavedContentTypes.indexOf(idContentType);

            if (index > -1) {
                unsavedContentTypes.splice(index, 1);
            }
        })

        this.resetUnsavedContentTypesException();
        this.getTemplateViewModel().unsavedContentTypes(unsavedContentTypes);
    }

    public setFallback(fallback:number): void {
        this.getTemplateViewModel().fallback(fallback);
    }

    public getFallback(): number {
        return this.getTemplateViewModel().fallback();
    }

    public setSaveFallback(saveFallback: boolean): void {
        this.getTemplateViewModel().saveFallback(saveFallback);
    }

    public getSaveFallback(): boolean {
        return this.getTemplateViewModel().saveFallback();
    }

    private createContentTypeSessionTarget(contentType) {

        let date: Date = new Date();
        let currentMonth: number = date.getMonth() + 1;
        let currentYear: number = date.getFullYear();
        let selectedYear = this.getYear();
        let isSelectedYearPassed: boolean = selectedYear < currentYear;

        let contentTypeData: ContentTypeData = {
            idContentType: Number(contentType.id),
            contentTypeName: contentType.name,
            exceptionMonths: []
        };
        for (let month: number = 1; month <= 12; month++) {

            let enabled = false;
            if (!isSelectedYearPassed && (month >= currentMonth)) {
                enabled = true;
            }

            let targetSession: TargetSession = {
                month: month,
                sessionTarget: null,
                enabled: enabled
            };
            contentTypeData.exceptionMonths.push(targetSession);
        }
        return contentTypeData;
    }

    public getContentTypesExceptionsSaveRequest() {

        let contentTypeList = this.getContentTypeList();
        let exceptions = [];
        for (const contentTypeListElement of contentTypeList) {
            for (const exceptionMonth of contentTypeListElement.exceptionMonths) {

                exceptions.push({
                    idContentType: contentTypeListElement.idContentType,
                    contentTypeName: contentTypeListElement.contentTypeName,
                    month: exceptionMonth.month,
                    sessionTarget: exceptionMonth.sessionTarget
                });
            }
        }
        return {
            type: this.getType(),
            year: this.getYear(),
            brandId: this.getIdBrand(),
            contentTypesToDelete: this.getContentTypesToDelete().map((ct) => ct.idContentType ),
            exceptions: exceptions
        }
    }

    public setValidationSessionTargetsExceptions(messages) {
        this.validationsList.setMessages(messages);
    }
    public clearValidationSessionTargetsExceptions(): void {
        this.validationsList.clearMessages();
    }

    public getSavingElement(): Element {
        let popupTypeId = this.buildPopupTypeId();
        return document.getElementById(popupTypeId);
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/articleContentTypeSession_template.ts